import Mutations from '../../odata/mutations';

export default { ...new Mutations('explanation'), ...new Mutations('explanations') };
